var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.751,
    height: 47.001,
    viewBox: "0 0 38.751 47.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(-8592.695 -2460.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M8606.673,2664.929c0-3.711,0-7.421.008-11.132a.779.779,0,0,0-.369-.733q-6.371-4.434-12.728-8.887a.754.754,0,0,1-.388-.723c.028-.957.009-1.914.009-2.908h37.708a17.039,17.039,0,0,0,.016,2.118,1.877,1.877,0,0,1-1.024,1.978c-4.062,2.777-8.072,5.624-12.108,8.437a.737.737,0,0,0-.357.692c.014,2.35.008,4.7.008,7.048v.519l-4.046,1.349q-3.1,1.034-6.205,2.07a2.567,2.567,0,0,0-.343.174Z",
    transform: "translate(0 -158.372)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M8620.759,2479.4h-16.217a7.913,7.913,0,0,1,2.108-5.419,8.216,8.216,0,0,1,5.211-2.65,5.574,5.574,0,0,1-3.622-2.256,5.262,5.262,0,0,1-.906-4.173,5.39,5.39,0,1,1,5.975,6.4C8617.862,2472.133,8620.306,2474.808,8620.759,2479.4Z",
    transform: "translate(-9.986 0)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M8770.559,2471.351a8.213,8.213,0,0,1,5.951,3.608,7.862,7.862,0,0,1,1.364,4.456h-16.155a7.922,7.922,0,0,1,2.121-5.417,8.232,8.232,0,0,1,5.207-2.644,5.593,5.593,0,0,1-3.5-2.084,5.054,5.054,0,0,1-1.089-3.911,5.383,5.383,0,0,1,10.719.236A5.484,5.484,0,0,1,8770.559,2471.351Z",
    transform: "translate(-148.311 -0.03)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp2);
export default __webpack_public_path__ + "static/media/exp-2.2a1168e245a081425ba83458eaa522dc.svg";
export { ForwardRef as ReactComponent };